// src/components/common/MapLoadingSkeleton.js
import React from 'react';
import './MapLoadingSkeleton.css';

/**
 * MapLoadingSkeleton - Beautiful loading skeleton for Google Maps
 *
 * Shows a shimmer effect skeleton while the map loads to:
 * - Prevent layout shift
 * - Improve perceived performance
 * - Provide visual feedback
 *
 * @param {Object} props
 * @param {number} props.height - Height in pixels (default: 400)
 * @param {string} props.text - Optional loading text
 */
const MapLoadingSkeleton = ({ height = 400, text }) => {
  return (
    <div className="map-skeleton" style={{ height: `${height}px` }}>
      {/* Shimmer overlay */}
      <div className="map-skeleton__shimmer" aria-hidden="true" />

      {/* Decorative elements that look like map UI */}
      <div className="map-skeleton__controls">
        {/* Zoom controls skeleton */}
        <div className="map-skeleton__zoom">
          <div className="map-skeleton__zoom-btn" />
          <div className="map-skeleton__zoom-btn" />
        </div>

        {/* Map type selector skeleton */}
        <div className="map-skeleton__map-type" />
      </div>

      {/* Marker placeholders */}
      <div className="map-skeleton__markers" aria-hidden="true">
        <div className="map-skeleton__marker map-skeleton__marker--start" />
        <div className="map-skeleton__marker map-skeleton__marker--end" />
      </div>

      {/* Loading text */}
      {text && (
        <div className="map-skeleton__text">
          <div className="map-skeleton__spinner" />
          <span>{text}</span>
        </div>
      )}

      {/* Accessibility */}
      <div className="sr-only" role="status" aria-live="polite">
        {text || 'Loading map...'}
      </div>
    </div>
  );
};

export default MapLoadingSkeleton;
